<template>
    <div class="text-center icon-block">
        <img v-if="iconExists" :src="iconPath" :key="iconPath" @error="handleIconError" class="icon-mapdisplay" />
        <font-awesome-icon v-else :icon="['fas', 'spinner']" size="2xl" spin />
        <font-awesome-icon v-if="this.warning" :icon="['fas', 'circle']" class="icon-circle"
            :class="this.warningColorClass" size="6x" />
        <font-awesome-icon v-if="this.parking" :icon="['fas', 'circle']" class="icon-circle"
        :style="{opacity: 0.6,color: 'rgba(31, 123, 193, 0.8)'}" size="6x" />
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        warning: {
            type: Boolean,
            default: false
        },
        warningColor: {
            default: 'red'
        },
        parking: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            iconExists: true,
        };
    },
    computed: {
        iconPath() {
            return this.icon ? `/img/cars/${this.icon}` : '';
        },
        warningColorClass: function () {
            switch (this.warningColor) {
                case 'red':
                    return 'warning-red'
                case 'blue':
                    return 'warning-blue'
                default:
                    return 'warning-red'
            }
        },
    },
    watch: {
        iconPath: {
            immediate: true,
            handler(newPath) {
                if (!newPath) {
                    this.iconExists = false
                    return
                }

                fetch(newPath, { method: 'HEAD' })
                    .then(res => {
                        this.iconExists = res.ok
                    })
                    .catch(() => {
                        this.iconExists = false
                    })
            }
        }
    },
    methods: {
        handleIconError() {
            this.iconExists = false;
        },
    },
}
</script>

<style>
@keyframes warning {
    from {
        opacity: 0.1;
    }

    to {
        opacity: 0.6;
    }
}

.icon-circle {
    position: absolute;
    right: 12px;
    bottom: -15px;
}

.icon-mapdisplay {
    position: relative;
    z-index: 600;
}

.warning-red {
    z-index: 601;
    animation-duration: 0.5s;
    animation-name: warning;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    color: rgba(224, 22, 22, 0.8);
}

.warning-blue {
    opacity: 0.6;
    color: rgba(31, 193, 69, 0.8);
}

.icon-block {
    position: relative;
}
</style>
